<script>
	export let tempo = 100;
	export let lastTempo = 0;

	let sound = new Audio('tick.wav');
	let id = 0;

	function update() {
		lastTempo = tempo;
		let inter = 60000 / tempo;
		id = setInterval(play, inter);
	}

	function play() {
		sound.play();
		if (lastTempo != tempo) {
			stopTick();
			update();
		}
	}

	export function stopTick() {
		clearInterval(id);
		id = 0;
	}
</script>

<button on:click={e => id ? stopTick() : update()}>metronom</button>
<input style="width:30em" type=range bind:value={tempo} min=40 max=250>
<span style="font-size:2em">{tempo}</span>
